import { request } from '../util/request.js'
export function getUser(data, headers) {
    return request('get', 'shopro/user', data, headers);
}

export function indexRule(data) { //积分 红包规则
    return request('get', 'shopro/index/rule', data);
}

export function getUserIndex(data, headers) {
    return request('get', 'shopro/user/index', data, headers);
}

export function goodSearch(data) { //商品分类  （商品分类页使用）
    return request('get', 'shopro/goods/searchs', data);
}

export function informationInfo(data) { //咨询详情
    return request('get', 'shopro/information/info', data);
}

export function category(data) { //历史记录
    return request('get', 'shopro/category/index?id=1', data);
}

export function shoproCategory(data) { //商品分类  (全部商品使用)
    return request('get', 'shopro/category?id=1', data);
}
export function lists(data) { //商品列表
    return request('get', 'shopro/goods/lists', data);
}
export function detail(data) { //商品详情
    return request('get', 'shopro/goods/detail', data);
}
export function send(data) { //获取验证码
    return request('post', 'shopro/sms/send', data);
}
export function scoreSkuPrice(data) { //积分商城
    return request('get', 'shopro/score_goods_sku_price/index', data);
}
export function scoreSkuDetail(data) { //积分商城
    return request('get', 'shopro/score_goods_sku_price/detail', data);
}
export function commitIndex(data) { //评价详情
    return request('get', 'shopro/goods_comment/index', data);
}
export function register(data) { //注册
    return request('post', 'shopro/user/register', data);
}
export function accountLogin(data) { //登录
    return request('post', 'shopro/user/accountLogin', data);
}
export function address(data, headers) { //地址列表
    return request('get', 'shopro/address', data, headers);
}
export function addressEdit(data, headers) { //添加地址
    return request('post', 'shopro/address/edit', data, headers);
}
export function pre(data, headers) { //确认订单
    return request('post', 'shopro/order/pre', data, headers);
}
export function createOrder(data, headers) { //创建订单
    return request('post', 'shopro/order/createOrder', data, headers);
}

export function orderDetail(data, headers) { //订单详情
    return request('get', 'shopro/order/detail', data, headers);
}
export function prepay(data, headers) { //请求支付
    return request('post', 'shopro/pay/prepay', data, headers);
}
export function simplegoodsset(data, headers) { //获取指定商品集合
    return request('get', 'shopro/goods/like', data);
}
export function orderIndex(data, headers) { //我的订单列表
    return request('get', 'shopro/order/index', data, headers);
}
export function cartList(data, headers) { //购物车列表
    return request('post', 'shopro/cart', data, headers)
}
export function addCart(data, headers) { //添加购物车
    return request('post', 'shopro/cart/add', data, headers)
}
export function editCart(data, headers) { //修改购物车
    return request('post', 'shopro/cart/edit', data, headers)
}
export function pchome(data, headers) { //pc端首页信息
    return request('post', 'shopro/index/pchome', data)
}
export function banners_pc(data, headers) { //获取pc端轮播图
    return request('get', 'shopro/banners_pc/index', data)
}
export function orderConfirm(data, headers) { //确认收货
    return request('post', 'shopro/order/confirm', data, headers)
}
export function expressIndex(data, headers) { //物流信息
    return request('get', 'shopro/order_express/index', data, headers)
}
export function aftersaleDetail(data, headers) { //售后详情
    return request('get', 'shopro/order_aftersale/detail', data, headers)
}
export function orderItemDetail(data, headers) { //商品信息
    return request('get', 'shopro/order/itemDetail', data, headers)
}
export function aftersaleAdd(data, headers) { //提交售后
    return request('post', 'shopro/order_aftersale/aftersale', data, headers)
}
export function aftersaleCancel(data, headers) { //取消售后
    return request('post', 'shopro/order_aftersale/cancel', data, headers)
}
export function aftersaleDelete(data, headers) { //删除售后
    return request('post', 'shopro/order_aftersale/delete', data, headers)
}
export function newProduct(data, headers) { //新品发布 特价专区
    return request('get', 'shopro/goods/activitygoodslist', data)
}
export function myFavorite(data, headers) { //我的收藏
    return request('get', 'shopro/goods/favoriteList', data, headers)
}
export function Provinces(data, headers) { //省市区
    return request('get', 'shopro/address/area', data, headers)
}

export function purchaseAdd(data, headers) { //提交采购清单
    return request('post', 'shopro/purchase/add', data, headers)
}

export function userRestpwd(data, headers) { //提交密码
    return request('post', 'shopro/user/resetpwd', data, headers)
}

//shopro/index/upload
export function indexUpload(data, headers) { //修改密码
    return request('post', 'shopro/index/upload', data, headers)
}
//shopro/address/del
export function addressDel(data, headers) { //删除地址
    return request('post', 'shopro/address/del', data, headers)
}

export function addressInfo(data, headers) { //地址详情
    return request('get', 'shopro/address/info', data, headers)
}

export function userProfile(data, headers) { //修改个人信息
    return request('post', 'shopro/user/profile', data, headers)
}
// /shopro/user
export function shoproUser(data, headers) { //获取个人信息
    return request('get', 'shopro/user', data, headers)
}

export function shoproCoupons(data, headers) { // 优惠卷
    return request('get', 'shopro/coupons/index', data, headers)
}

export function couponsGet(data, headers) { // 领取优惠卷优惠卷
    return request('get', 'shopro/coupons/get', data, headers)
}
export function orderCoupons(data, headers) { // 领取优惠卷优惠卷
    return request('post', 'shopro/order/coupons', data, headers)
}

export function orderComment(data, headers) { // 评价
    return request('post', 'shopro/order/comment', data, headers)
}

export function userWalletLog(data, headers) { // 钱包明细
    return request('get', 'shopro/user_wallet_log', data, headers)
}

//删除订单shopro/order/delete
export function orderDelete(data, headers) { // 钱包明细
    return request('post', 'shopro/order/delete', data, headers)
}
//shopro/order_express/detail
export function orderExpressDetail(data, headers) { // 包裹明细
    return request('get', 'shopro/order_express/detail', data, headers)
}
export function recruitIndex(data, headers) { // 招聘中心
    return request('get', 'shopro/recruit/index', data)
}

export function informationIndex(data, headers) { // 最新资讯
    return request('get', 'shopro/information/index', data)
}
//shopro/index/help

export function indexHelp(data, headers) { // 帮助中心
    return request('get', 'shopro/index/help', data)
}

export function indexRichtext(data, headers) { // 帮助中心
    return request('get', 'shopro/index/richtext', data)
}
export function brandIndex(data, headers) { // 品牌检索
    return request('get', 'shopro/brand/index', data)
}
export function orderCanel(data, headers) { // 取消订单
    return request('post', 'shopro/order/cancel', data, headers)
}

//shopro/pay/scanpay
export function payScanpay(data, headers) { // 二维码支付
    return request('post', 'shopro/pay/scanpay', data, headers)
}

export function goodsFavorite(data, headers) { //加入收藏
    return request('post', 'shopro/goods/favorite', data, headers)
}

export function userLetterIndex(data, headers) { //站内收件箱
    return request('get', 'shopro/user_letter/index', data, headers)
}

export function userLetterSave(data, headers) { //发送站内信
    return request('post', 'shopro/user_letter/save', data, headers)
}

export function userLetterDel(data, headers) { //删除站内信
    return request('post', 'shopro/user_letter/del', data, headers)
}

export function invoiceAdd(data, headers) { //新增开票信息
    return request('post', 'shopro/invoice/add', data, headers)
}

export function invoiceList(data, headers) { //开票信息列表
    return request('get', 'shopro/invoice/lists', data, headers)
}

export function invoiceDel(data, headers) { //删除开票信息列表
    return request('post', 'shopro/invoice/del', data, headers)
}
export function invoiceEdit(data, headers) { //编辑开票信息列表
    return request('post', 'shopro/invoice/edit', data, headers)
}

export function purchaseLists(data, headers) { //采购清单列表
    return request('post', 'shopro/purchase/lists', data, headers)
}


// WEBPACK FOOTER //
// ./src/api/index.js